<template>
  <div class="c-flex-c1">
    <v-layout align-center class="c-flex-00a crx-toolbar subheading">
      <v-btn
      @click="$emit('onClose')" 
      flat icon>
        <v-icon color="color1">mdi-arrow-left</v-icon>
      </v-btn>
      <div class="c-flex-r1 align-center text-sans font-weight-bold">
        Select address
      </div>
      <v-spacer></v-spacer>

      <v-layout align-center pl-2 pr-2 shrink>
        <span class="caption">
          <c-list-items-per-page
          :page="page"
          :rowsPerPage="rowsPerPage"
          :rowsPerPageTV.sync="rowsPerPageTV"
          :searchMatches="searchMatches">

          </c-list-items-per-page>

        </span>
        <v-btn
        flat
        icon
        class="ma-0"
        color="blue"
        :disabled="page <= 1"
        @click="page--">
          <v-icon>keyboard_arrow_left</v-icon>
        </v-btn>

        <v-btn
        flat
        icon
        color="blue"
        class="ma-0"
        :disabled="page >= paginationLength"
        @click="page++">
          <v-icon>keyboard_arrow_right</v-icon>
        </v-btn>
      </v-layout>
    </v-layout>
    <!-- MAIN CONTENT -->
    <div style="overflow: auto; height: 100%;" class="background darken-1">

      <v-layout>
        
        <v-flex xs12 sm6>
          <v-card class="ma-3">
            <v-text-field
            v-model="searchText"
            solo
            prepend-inner-icon="search"
            placeholder="Search"
            color="text"
            hide-details
            clearable>
            </v-text-field>
            <div class="pa-4">

              <v-text-field
              v-model="formData.address"
              label="Address line 1">
              </v-text-field>

              <v-text-field
              v-model="formData.address2"
              label="Address line 2">
              </v-text-field>

              <v-text-field
              v-model="formData.state"
              label="State / Province">
              </v-text-field>

              <v-text-field
              v-model="formData.city"
              label="City">
              </v-text-field>

              <v-text-field
              v-model="formData.zip_code"
              label="ZIP code">
              </v-text-field>

              <v-text-field
              v-model="formData.country"
              label="Country">
              </v-text-field>

              <v-text-field
              v-model="formData.phone"
              label="Address Phone number">
              </v-text-field>

            </div>
          </v-card>
        </v-flex>

        <v-flex xs12 sm6>
          <v-card class="ma-3">
            <div>

              <complete-row
              v-for="item in paginatedArray" 
              :key="item.tempID"
              :item="item"
              @click.native="clickRow(item)">
              </complete-row>

              <div class="text-xs-center">
                <v-pagination
                v-if="paginationLength > 1"
                v-model="page"
                :length="paginationLength"
                circle>

                </v-pagination>
              </div>

            </div>
          </v-card>
        </v-flex>

      </v-layout>
    </div>
    <!-- END MAIN CONTENT -->

    <div class="c-hr"></div>
    <v-layout align-center class="c-flex-00a crx-toolbar subheading">
      <v-spacer></v-spacer>
      <v-btn color="blue" flat :loading="loading">
        OK
      </v-btn>
    </v-layout>
  </div>
</template>

<script>
import ListController from '@/mixins/ListController'
import CompleteRow from './row'
import Vue from 'vue'

export default {
  mixins: [ListController],
  components: {
    CompleteRow
  },
  data () {
    return {
      loading: false,
      formData: {}
    }
  },
  computed: {
  },
  methods: {
    open () {

    },
    clickRow (item) {

    },
    addressToString (address) {
      var str = ''
      if (address) {
        var lines = [address.address, address.address2, address.state, address.city, address.zip_code, address.country]
        for (var line of lines) {
          if (line) {
            str += line + '\n'
          }
        }
      }
      return str
    },
    search (items) {
      if ((this.searchText || '').length > 0) {
        var keywords = (this.searchText || '').toLowerCase().split(' ')
        items = items.filter(item => {
          return keywords.every(keyword => {
            return (item.str.toLowerCase()).indexOf(keyword) > -1
          })
        })
      }
      return items
    },
    sort (headerIndex, items, sortAscending) {
      if (headerIndex === 0) { // id
        return items.sort((a, b) => {
          return sortAscending ? a.id - b.id : b.id - a.id
        })
      } else if (headerIndex === 1) { // Inventory
        return items.sort((a, b) => {
          return sortAscending ? a.inventory - b.inventory : b.inventory - a.inventory
        })
      } else if (headerIndex === 2) { // Date of entry
        return items.sort((a, b) => {
          return sortAscending ? new Date(b.date_of_entry) - new Date(a.date_of_entry) : new Date(a.date_of_entry) - new Date(b.date_of_entry)
        })
      } else if (headerIndex === 3) { // Expiry
        return items.sort((a, b) => {
          return sortAscending ? new Date(b.expiry_date) - new Date(a.expiry_date) : new Date(a.expiry_date) - new Date(b.expiry_date)
        })
      } else if (headerIndex === 4) { // Supplier
        return items.sort((a, b) => {
          var supplierA = (this.$store.state.db.suppliers.suppliers[a.supplier_id] || {}).name || ''
          var supplierB = (this.$store.state.db.suppliers.suppliers[b.supplier_id] || {}).name || ''
          return sortAscending ? supplierA.localeCompare(supplierB) : supplierB.localeCompare(supplierA)
        })
      }
    }
  },
  mounted () {
    this.$axios.get('/addresses/')
        .then(response => {
          this.items = response.data.map(item => {
            item.str = this.addressToString(item)
            return item
          })
        })
        .catch(error => this.$root.$errorSnackbar(error))
  }
}
</script>

<style scoped lang="scss">
.sort-arrow {
  opacity: 0;

  &.visible {
    opacity: 1;
  }
  &.rotate {
    transform: rotate( -180deg );
  }
}
</style>

